import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';

import Template from '../tempaltes/Template';
import Router from './Router';
import { switchTemplate } from '../db/View';
import { routes } from './routes';
import { listenStats } from '../db/sockets';
import { getLanguages } from '../db/Language';
import { getTranslate } from '../db/Translate';
import { getEx } from '../db/Ex';

const Main = (props) => {
	const {
		listenStats,
		getLanguages,
		getEx,
		location: { pathname } = {},
		template,
		view = {},
		getTranslate
	} = props

	const setTranslate = () => {
		const find = routes.find(({ path }) => pathname === path);
		if (find) {
			if (!find.template) {
				find.template = 'default';
			}

			if (find.template !== view.template) {
				template(find.template);
			}
		}
	}

	useEffect(() => {
		listenStats();
		getLanguages();
		getEx();
		setTranslate()
	}, [])

	useEffect(() => {
		getTranslate(view.lang);
		setTranslate()
	}, [view.lang])

	return (
		<Template>
			<Router />
		</Template>
	)
}



function mapStateToProps(state) {
	return {
		view: state.view
	}
}
function matchDispatchToProps(dispatch) {
	return bindActionCreators({ template: switchTemplate, getEx, listenStats, getLanguages, getTranslate }, dispatch)
}


export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Main))